import { render, staticRenderFns } from "./cascader-defaultValue-editor.vue?vue&type=template&id=accf4f04&scoped=true&"
import script from "./cascader-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./cascader-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accf4f04",
  null
  
)

export default component.exports